import { initErrorReporter } from './utils/errorReporter';
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App.jsx'
import './index.css'
import { registerSW } from 'virtual:pwa-register'

// Inicializa o reporter de erros o mais cedo possível
initErrorReporter({
  appVersion: import.meta.env.VITE_APP_VERSION || 'unknown',
});

// Registrar Service Worker para PWA usando o helper do vite-plugin-pwa
const updateSW = registerSW({
  onNeedRefresh() {
    // Exibe um toast ou modal para notificar o usuário que uma nova versão está disponível
    console.log('New content available, please refresh.');
    // Aqui você pode adicionar lógica para mostrar uma notificação ao usuário
    // Por exemplo, uma chamada para um toast de atualização:
    // toast.info('Nova versão disponível! Clique para atualizar.', {
    //   onClick: () => updateSW(true), // Força a atualização e recarrega a página
    //   duration: Infinity,
    // });
  },
  onOfflineReady() {
    console.log('App is ready to work offline.');
  },
  onRegistered(r) {
    if (r) {
      console.log('Service Worker registered!');
      // Se houver um Service Worker esperando, envie a mensagem SKIP_WAITING
      if (r.waiting) {
        r.waiting.postMessage({ type: 'SKIP_WAITING' });
      }

      // Check for updates every time the page loads (aggressive)
      // This helps push new SW versions even if the browser doesn't check often
      // r.update() will be called automatically by onNeedRefresh() if enabled.
      // If you want to force check for updates, you can call r.update() here.
      // r.update();

      r.addEventListener('updatefound', () => {
        const newWorker = r.installing;
        if (newWorker) {
          newWorker.addEventListener('statechange', () => {
            if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
              newWorker.postMessage({ type: 'SKIP_WAITING' });
            }
          });
        }
      });
    } else {
      console.log('Service Worker not registered.');
    }
  },
  onRegisterError(error) {
    console.error('Service Worker registration failed:', error);
  },
});

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
